import { sportSupportsScoreboard } from '@/components/scoreboard/use-scoreboard';
import { Event } from '@/feature/event-details-sbk/types';
import { getHudHeight } from '@/feature/event-details-sbk/utils/get-hud-height';
import { useEventHasScoreboard, useEventStatus } from '@/hooks/use-sbk-event-details-cache';

/**
 * Derives the primary HUD height for an SBK event, cache-first.
 *
 * Both the sheet title (which uses the height as the scroll threshold for the condensed-title
 * crossfade) and the sheet content (which renders the actual <EventHud> at this height) call this,
 * so the threshold and the rendered HUD share one source of truth and can't drift apart.
 */
export const useSbkHudHeight = (event: Event) => {
    const eventStatus = useEventStatus(event.id) ?? event.status;
    const isPregame = eventStatus === 'NOTSTARTED' || eventStatus === 'UNKNOWN';
    const hasScoreboard = useEventHasScoreboard(event) ?? false;
    // A sport can carry period data but have no ScoreBoardGrid builder (e.g. esports). Require a
    // builder so we never reserve carousel height for a scoreboard that can't render.
    const showScoreboard = hasScoreboard && !isPregame && sportSupportsScoreboard(event.sport);
    const hudHeight = getHudHeight({ eventStatus, showScoreboard, sportName: event.sport.name });
    return { eventStatus, showScoreboard, hudHeight };
};
